import React, {useEffect, useState} from "react";
import './select.scss';

const Select = ({name, label, options = [], value = '', onChange, validate}) => {
    const [touched, setTouched] = useState(false);

    useEffect(() => {
        validate && setTouched(true);
    }, [validate])

    return <div>
        <div className={'select-main'}>
            <select
                name={name}
                defaultValue={''}
                className={`${value === '' && 'un-selected'} ${touched && !value && 'input-error'}`}
                onChange={e => onChange(e.target.value, false)}
                onBlur={() => setTouched(true)}
            >
                <option value={''} disabled >{label}</option>
                {
                    options.map(({value, label}) => <option key={value} value={value}>{label}</option>)
                }
            </select>
        </div>
        <span className={touched && !value ? 'error-msg' : ''}>
            Selecciona una opción del menú desplegable
        </span>
    </div>
}

export default Select;